// client/src/components/ProductCarousel.js
import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import ProductCard from './ProductCard';

const ProductCarousel = ({ title, products }) => {
  if (!Array.isArray(products) || products.length === 0) {
    return null;
  }

  return (
    <Container maxWidth={false} component="section" sx={{ mb: 5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
        <Box sx={{ width: 4, height: 28, borderRadius: 2, bgcolor: 'primary.main' }} />
        <Typography variant="h5" fontWeight={800} letterSpacing="-0.02em">{title}</Typography>
      </Box>
      {/* As many columns as fit the full width, so rows stay packed edge to edge. */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap: 2,
        }}
      >
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </Box>
    </Container>
  );
};

export default ProductCarousel;
